import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import { Provider } from "react-redux";
import Store from "./redux/store";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { BrowserRouter } from "react-router-dom";
import { LEOPAY_TITLE_NAME } from "./utils/Constant";

// Function to set CSS variables based on the portal
const setCSSVariables = () => {
  const rootElement = document.documentElement;
  const title = process.env.REACT_APP_TITLE;

  if (title === "Paytom Merchant Portal") {
    rootElement.style.setProperty(
      "--primary-color",
      process.env.REACT_APP_PRIMARY_COLOR_PAYTOM
    );
    rootElement.style.setProperty(
      "--navbar-border-color",
      process.env.REACT_APP_NAVBAR_BORDER_COLOR_PAYTOM
    );
    rootElement.style.setProperty(
      "--navbar-text-color",
      process.env.REACT_APP_NAV_TEXT_COLOR_PAYTOM
    );
    rootElement.style.setProperty(
      "--navbar-active-text-color",
      process.env.REACT_APP_NAV_MENU_ACTIVE_COLOR_PAYTOM
    );
  } else if (title === "KlikPay Merchant Portal") {
    rootElement.style.setProperty(
      "--primary-color",
      process.env.REACT_APP_PRIMARY_COLOR_KLIKPAY
    );
    rootElement.style.setProperty(
      "--navbar-border-color",
      process.env.REACT_APP_NAVBAR_BORDER_COLOR_KLIKPAY
    );
    rootElement.style.setProperty(
      "--navbar-text-color",
      process.env.REACT_APP_NAV_TEXT_COLOR_KLIKPAY
    );
    rootElement.style.setProperty(
      "--navbar-active-text-color",
      process.env.REACT_APP_NAV_MENU_ACTIVE_COLOR_KLIKPAY
    );
  } else if (title === "QRBonPay Merchant Portal") {
    rootElement.style.setProperty(
      "--primary-color",
      process.env.REACT_APP_PRIMARY_COLOR_QRBonPay
    );
    rootElement.style.setProperty(
      "--navbar-border-color",
      process.env.REACT_APP_NAVBAR_BORDER_COLOR_QRBonPay
    );
    rootElement.style.setProperty(
      "--navbar-text-color",
      process.env.REACT_APP_NAV_TEXT_COLOR_QRBonPay
    );
    rootElement.style.setProperty(
      "--navbar-active-text-color",
      process.env.REACT_APP_NAV_MENU_ACTIVE_COLOR_leopay
    );
  } else if (title === LEOPAY_TITLE_NAME) {
    rootElement.style.setProperty(
      "--primary-color",
      process.env.REACT_APP_PRIMARY_COLOR_leopay
    );
    rootElement.style.setProperty(
      "--navbar-border-color",
      process.env.REACT_APP_NAVBAR_BORDER_COLOR_leopay
    );
    rootElement.style.setProperty(
      "--navbar-text-color",
      process.env.REACT_APP_NAV_TEXT_COLOR_leopay
    );
    rootElement.style.setProperty(
      "--navbar-active-text-color",
      process.env.REACT_APP_NAV_MENU_ACTIVE_COLOR_leopay
    );
  }

  // Set the secondary color (assuming it's the same for all portals)
  rootElement.style.setProperty(
    "--secondary-color",
    process.env.REACT_APP_SECONDARY_COLOR
  );
};

const AppWithTitleEffect = () => {
  useEffect(() => {
    // Dynamically set the title based on environment
    if (process.env.REACT_APP_ENV === "klikpay") {
      document.title = "KlikPay Merchant Portal";
    } else if (process.env.REACT_APP_ENV === "paytom") {
      document.title = "Paytom Merchant Portal";
    } else if (process.env.REACT_APP_ENV === "qrbonpay") {
      document.title = "QRBonPay Merchant Portal";
    } else if (process.env.REACT_APP_ENV === "qa") {
      document.title = "QA Admin Portal";
    } else if (process.env.REACT_APP_ENV === "leopay") {
      document.title = "Merchant Portal";
    } else {
      document.title = "Admin Portal";
    }

    // Call the function to set CSS variables based on the portal
    setCSSVariables();
  }, []);

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={Store}>
      <AppWithTitleEffect />
    </Provider>
  </BrowserRouter>
);

serviceWorkerRegistration.register();
reportWebVitals();
